import { colors } from '@globals/themes/defaultTheme'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import { ReactElement } from 'react'
import { AutoCompleteRenderChipProps } from './StandardAutoCompleteSearch'

const autoCompleteChipStyle: SxProps = {
  m: 0.25,
  '&.MuiChip-root': {
    minHeight: 32,
  },
}

const chipLabelStyles: SxProps = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}

export type AutoCompleteChipProps = AutoCompleteRenderChipProps & {
  label: string
  labelStyles?: SxProps
  avatar?: ReactElement
  chipStyle?: SxProps
  icon?: ReactElement
  backgroundColor?: string
  borderColor?: string
}

const AutoCompleteChip: React.FC<AutoCompleteChipProps> = ({
  label,
  labelStyles = chipLabelStyles,
  avatar,
  chipStyle,
  icon,
  backgroundColor = colors.grayUltraLight,
  borderColor = 'transparent',
  disabled,
  onDelete,
  ...otherProps
}) => {
  return (
    <Chip
      variant="outlined"
      size="small"
      avatar={avatar}
      label={
        <Typography variant="body1" sx={labelStyles}>
          {label}
        </Typography>
      }
      sx={{ ...autoCompleteChipStyle, ...chipStyle, backgroundColor, borderColor }}
      onDelete={!disabled ? onDelete : undefined}
      deleteIcon={<CloseOutlinedIcon />}
      icon={icon}
      disabled={disabled}
      {...otherProps}
    />
  )
}

export default AutoCompleteChip
